import * as React from 'react';
export const caretDownSvg = React.forwardRef(function caretDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.186 10.86 4.13 6.582A1 1 0 0 1 4.943 5h6.114a1 1 0 0 1 .814 1.581l-3.057 4.28a1 1 0 0 1-1.628 0Z',
    }),
  );
});
caretDownSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var caretDown = {
  category: 'icon',
  colorable: true,
  name: 'caretDown',
  svg: caretDownSvg,
};
